import { getField, updateField } from "vuex-map-fields";
import Repository from "@/repository";

const FUELCARD_API = "/fuelCard";

// ----------------------- STATE ------------------------- //
const state = {
  fuelcard_data: [],
  currentIndex: -1
};

// ----------------------- GETTERS ----------------------- //
const getters = {
  getFuelCard: state => getField(state.fuelcard_data[state.currentIndex]),

  getCurrentFuelCard: state => {
    return state.fuelcard_data[state.currentIndex];
  }
};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
  updateFuelCard(state, payload) {
    updateField(state.fuelcard_data[state.currentIndex], payload);
  },

  setCurrentIndexByID(state, theID) {
    state.currentIndex = state.fuelcard_data.findIndex(
      fuelcard => fuelcard.id == theID
    );
  },

  loadAllFuelCards(state, payload) {
    state.fuelcard_data = payload.data;
    state.currentIndex = 0;
  },

  addFuelCard(state, payload) {
    state.fuelcard_data.push(payload.data);
    state.currentIndex = state.fuelcard_data.length - 1;
  },

  saveFuelCard(state, payload) {
    state.fuelcard_data[state.currentIndex] = payload.data;
  },

  fetchFuelCard(state, payload) {
    if (state.currentIndex == -1) {
      state.fuelcard_data.push(payload.data);
      state.currentIndex = 0;
    } else {
      state.fuelcard_data[state.currentIndex] = payload.data;
    }
  },

  deleteFuelCard(state, payload) {
    state.currentIndex = state.fuelcard_data.findIndex(
      fuelcard => fuelcard.id == payload.data.id
    );
    state.fuelcard_data.splice(state.currentIndex, 1);
  },
  reset(state) {
    state.fuelcard_data = []
    state.currentIndex = -1
  }
};

// ----------------------- ACTIONS -------------------- //
const actions = {
  async loadAllFuelCards({ commit }) {
    try {
      commit("loadAllFuelCards", await Repository.get(`${FUELCARD_API}`));
    } catch (error) {
      console.log(error);
    }
  },

  async addFuelCard({ commit }) {
    await Repository.get(`${FUELCARD_API}/new`)
      .then(response => {
        commit("addFuelCard", response);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async saveFuelCard({ state, commit }) {
    try {
      commit(
        "saveFuelCard",
        await Repository.post(
          `${FUELCARD_API}`,
          state.fuelcard_data[state.currentIndex]
        )
      );
    } catch (error) {
      console.log(error);
    }
  },

  async fetchFuelCard({ commit }, payloadID) {
    try {
      commit(
        "fetchFuelCard",
        await Repository.get(`${FUELCARD_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async deleteFuelCard({ commit }, payloadID) {
    try {
      commit(
        "deleteFuelCard",
        await Repository.delete(`${FUELCARD_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async searchFuelCards({ commit }, searchTerm) {
    try {
      commit(
        "loadAllFuelCards",
        await Repository.get(`${FUELCARD_API}/search?q=${searchTerm}`)
      );
    } catch (error) {
      console.log(error);
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
